import axios from 'axios';

const VERIFY_URL = "https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/verify";
const REFRESH_URL = "https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/refresh";

/** CRA only auto-loads `.env` from the project root, not `src/.env` — fall back so verify/refresh always send a key. */
const DEFAULT_API_KEY = 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB';

const requestConfig = {
    headers: {
        'x-api-key': process.env.REACT_APP_AWS_API_GATEWAY_KEY || DEFAULT_API_KEY,
    },
};

let authInterceptorInitialized = false;

function migrateLegacySessionAuth() {
    const legacyToken = sessionStorage.getItem('token');
    const legacyUser = sessionStorage.getItem('user');
    const hasAccessToken = !!localStorage.getItem('accessToken');
    const hasUser = !!localStorage.getItem('user');

    if (!hasAccessToken && legacyToken) {
        localStorage.setItem('accessToken', legacyToken);
    }
    if (!hasUser && legacyUser) {
        localStorage.setItem('user', legacyUser);
    }

    if (legacyToken) {
        sessionStorage.removeItem('token');
    }
    if (legacyUser) {
        sessionStorage.removeItem('user');
    }
}

migrateLegacySessionAuth();

export function getUser() {
    const user = localStorage.getItem('user');
    if (user === 'undefined' || !user) {
        return null;
    }
    try {
        return JSON.parse(user);
    } catch {
        return null;
    }
}

/** Merge partial updates into the stored user (no backend fetch). Returns updated user or null. */
export function updateUser(updates) {
    const user = getUser();
    if (!user) {
        return null;
    }
    const updatedUser = { ...user, ...updates };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    return updatedUser;
}

/** Mark onboarding complete in local storage before the next backend sync. */
export function setOnboardingComplete(complete = true) {
    return updateUser({ onboardingComplete: complete });
}

export function getAccessToken() {
    return localStorage.getItem('accessToken');
}

// Backward-compatible alias used across older modules.
export function getToken() {
    return getAccessToken();
}

export function getRefreshToken() {
    return localStorage.getItem('refreshToken');
}

export function setUserSession(user, accessToken, refreshToken) {
    console.log('setting user session...')
    console.log('user', user)
    console.log('accessToken', accessToken)
    console.log('refreshToken', refreshToken)
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('accessToken', accessToken);
    if (refreshToken) {
        console.log('setting refresh token this is if it exists...')
        localStorage.setItem('refreshToken', refreshToken);
    } else {
        localStorage.removeItem('refreshToken');
    }
}

export function resetUserSession() {
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
}

// Returns the new access token on success, null on failure.
async function tryRefreshAccessToken() {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return null;

    try {
        const response = await axios.post(REFRESH_URL, { refreshToken }, requestConfig);
        const { accessToken, refreshToken: newRefreshToken } = response.data;
        if (!accessToken) return null;

        localStorage.setItem('accessToken', accessToken);
        if (newRefreshToken) {
            localStorage.setItem('refreshToken', newRefreshToken);
        }

        return accessToken;
    } catch (error) {
        return null;
    }
}

function updateRequestToken(config, newToken) {
    if (config?.headers?.Authorization) {
        config.headers.Authorization = `Bearer ${newToken}`;
    }

    if (!config?.data) return;

    try {
        const payload = typeof config.data === 'string' ? JSON.parse(config.data) : config.data;
        if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'token')) {
            payload.token = newToken;
            config.data = typeof config.data === 'string' ? JSON.stringify(payload) : payload;
        }
    } catch {
        // Ignore non-JSON request payloads.
    }
}

export function initializeAuthInterceptor() {
    if (authInterceptorInitialized) return;
    authInterceptorInitialized = true;

    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            const status = error?.response?.status;
            const originalRequest = error?.config;
            const requestUrl = originalRequest?.url || '';

            if (!originalRequest || status !== 401 || originalRequest._retry) {
                throw error;
            }

            // Avoid auth-loop retries for endpoints that should not refresh.
            if (
                requestUrl.includes('/login')
                || requestUrl.includes('/register')
                || requestUrl.includes('/refresh')
                || requestUrl.includes('/resetpass')
            ) {
                throw error;
            }

            const refreshToken = getRefreshToken();
            if (!refreshToken) {
                resetUserSession();
                throw error;
            }

            originalRequest._retry = true;
            const newToken = await tryRefreshAccessToken();
            if (!newToken) {
                resetUserSession();
                throw error;
            }

            updateRequestToken(originalRequest, newToken);
            return axios(originalRequest);
        }
    );
}

export async function isUserLoggedIn() {
    try {
        const token = getAccessToken();
        const user = getUser();

        console.log('token', token);
        console.log('user', user);

        if (!token || !user) return false;

        const requestBody = { user, token };

        try {
            const response = await axios.post(VERIFY_URL, requestBody, requestConfig);
            return response.status === 200;
        } catch (error) {
            // Access token expired or invalid — try refreshing once (only if we have a refresh token).
            console.log('error: ', error);
            if (error.response?.status === 401) {
                const refreshToken = getRefreshToken();
                if (!refreshToken) {
                    // Cannot rotate session; do not wipe storage (avoids "instant logout" when login did not persist refresh).
                    return false;
                }
                const newToken = await tryRefreshAccessToken();
                if (!newToken) {
                    resetUserSession();
                    return false;
                }

                const retryBody = { user, token: newToken };
                const retryResponse = await axios.post(VERIFY_URL, retryBody, requestConfig);
                return retryResponse.status === 200;
            }
            throw error;
        }
    } catch (error) {
        console.error('Login verification failed:', error);
        return false;
    }
}
    